import React from "react";
import { joinClassnames } from "utils/map-modifier";
import "./index.scss";

interface CloseProps {
  color: string;
  background: string;
  onClick?: () => void;
  className?: string;
}

const Close: React.FC<CloseProps> = ({
  color,
  background,
  onClick,
  className,
}) => (
  <span
    className={joinClassnames("remove-icon", className)}
    style={{
      color,
      background,
    }}
    onClick={onClick}
  >
    <span>＋</span>
  </span>
);

export default Close;
